export const SET_USER_GROUPS_LOADED = "SET_USER_GROUPS_LOADED";

export const setUserGroupsLoaded = (userGroupsLoaded: boolean) => {
  return {
    userGroupsLoaded,
    // tslint:disable-next-line:object-literal-sort-keys
    type: SET_USER_GROUPS_LOADED
  };
};
